import React from 'react';
import Image from 'components/image';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useBreakpoints from 'hooks/use-breakpoints';
import { imageSourceBreakpoints } from 'js/breakpoints';

const SearchTeaser = ({
  url,
  heading,
  image,
  backgroundColor,
  categoryLabel,
  className,
  preloadImage,
}) => {
  const { isMobile } = useBreakpoints(true);

  return (
    <a
      href={url}
      className={cn('search-teaser', {
        [className]: className,
      })}
    >
      <div
        className="search-teaser__background"
        role="presentation"
        style={{ backgroundColor: backgroundColor }}
      ></div>
      <div className="search-teaser__container">
        <div className="search-teaser__image-aligner">
          <div
            className={cn('search-teaser__image-holder', {
              'search-teaser__image-holder_no-image': !image,
            })}
          >
            {image && (
              <Image
                {...image}
                sources={[
                  {
                    width: 190,
                    height: 183,
                    media: imageSourceBreakpoints.xs,
                  },
                  {
                    width: 324,
                    height: 280,
                    media: imageSourceBreakpoints.s,
                  },
                  {
                    width: 262,
                    height: 226,
                    media: imageSourceBreakpoints.m,
                  },
                  {
                    width: 288,
                    height: 250,
                    media: imageSourceBreakpoints.l,
                  },
                ]}
                {...(!preloadImage && { loading: 'lazy' })}
                {...(preloadImage && { fetchPriority: 'high' })}
                fluid={isMobile}
                className="search-teaser__image image_size_search-teaser"
              />
            )}
          </div>
        </div>
        <div className="search-teaser__content">
          {categoryLabel && (
            <span className="search-teaser__category">{categoryLabel}</span>
          )}
          {heading && (
            <h2 className="search-teaser__heading">
              <span className="search-teaser__heading-text">{heading}</span>
            </h2>
          )}
        </div>
      </div>
    </a>
  );
};

SearchTeaser.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  heading: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  backgroundColor: PropTypes.string,
  categoryLabel: PropTypes.string,
  preloadImage: PropTypes.bool,
};

SearchTeaser.viewModelMeta = {
  className: 'ignore',
  preloadImage: 'ignore',
};

export default SearchTeaser;
